export default function(nga, admin) {
    let entity = admin.getEntity('gamevrlicence')
        .label('LICENCES_GAME_VR')
        .url(function(entity, view, id) {
            if(id)
                return 'gamevr/licence/' + encodeURIComponent(id);

            return 'gamevr/licence';
        });

    let pad = function (n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    entity.listView()
        .fields([
            nga.field('id').label('ID').isDetailLink(true),
            nga.field('licence').label('LICENCE').map(function (value, entry) {
                return entry['licence.licence'];
            }).template('<entity-show type="\'licence\'" id="entry.values[\'licence.id\']" text="value"></entity-show>'),
            nga.field('gamevr').label('GAMEVR').map(function (value, entry) {
                return entry['gamevr.name'];
            }).template('<entity-show type="\'gamevr\'" id="entry.values[\'gamevr.id\']" text="value"></entity-show>'),
            nga.field('purchase.order').label('ORDER').isDetailLink(true)
                .template('<entity-edit type="\'purchase\'" id="entry.values[\'purchase.id\']" text="value"></entity-edit>'),
            nga.field('created', 'date').label('CREATED').format('yyyy-MM-dd'),

        ])
        .sortDir('ASC')
        .url('gamevr/licences');

    entity.creationView().fields([
        nga.field('gamevr', 'reference')
            .map(function(value, entry) {
                return entry['gamevr.id'];
            })
            .targetEntity(nga.entity('game').url('gamevrs'))
            .targetField(nga.field('name'))
            .perPage(0),
        nga.field('licence', 'reference')
            .map(function(value, entry) {
                return entry['licence.id'];
            })
            .targetEntity(nga.entity('licence').url('licences'))
            .targetField(nga.field('licence'))
            .perPage(0),
        nga.field('purchase', 'reference')
            .map(function(value, entry) {
                return entry['purchase.id'];
            })
            .targetEntity(nga.entity('purchase').url('purchases'))
            .targetField(nga.field('order').map(function (value, entry) {
                let date = ParseDate(entry['created']);

                if(date)
                    return date.getFullYear() + "" + date.getMonth() + "" + date.getDate() + "" + pad(entry['id'], 4);
            }))
            .perPage(0),
        nga.field('created', 'date').format('yyyy-MM-dd').map(ParseDate)
    ]).onSubmitError(['error', 'form', 'progression', 'notification', '$filter', function(error, form, progression, notification, $filter) {

        $(':input').each(function(){
            $(this).closest('.form-field').removeClass('has-error').find('.help-block.error').remove();
        });

        error.data.fields.forEach(function(error, index){
            let input = $('[name='+error.property_path+']');
            $('<span class="help-block error">'+error.message+'</span>').insertAfter(input);
            input.closest('.form-field').addClass('has-error');
        });

        progression.done();

        notification.log($filter('translate')(`INVALID_DETAILS_IN_FORM`), { addnCls: 'humane-flatty-error' });

        return true;
    }]);

    entity.editionView().fields(
        entity.creationView().fields()
    ).onSubmitError(entity.creationView().onSubmitError());

    entity.deletionView();

    return entity;
}



/** WEBPACK FOOTER **
 ** ./js/entities/gamevrlicence/config.js
 **/